import React from 'react'
import { WhatsappTicketsView } from '../components/whatsapp/WhatsappTicketsView'

const WhatsappCentralAmparo: React.FC = () => (
  <WhatsappTicketsView
    origin="central-amparo"
    moduleName="atendimentos_whatsapp_central_amparo"
    title="Whatsapp Central Amparo"
  />
)

export default WhatsappCentralAmparo
